import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// React Router v6 removed automatic scroll restoration. Without this component,
// route changes preserve previous scroll position — user clicking a navbar link
// from mid-page lands mid-page on the new route.
//
// Mounted inside <BrowserRouter> in App.tsx. Listens to pathname; resets scroll
// to top instantly (NOT smooth) to avoid overlap with route entrance animation.
// Hash anchors (e.g., /faq#question) preserve native browser behavior because
// pathname doesn't change on hash-only nav.
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior });
  }, [pathname]);
  return null;
}
